/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Row, Col, Spinner, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faCheck,
  faMinusCircle,
  faPencil,
} from "@fortawesome/free-solid-svg-icons";
import useCreateAssessmentKitTopic from "./useCreateAssessmentKitTopic";
import { SkillSearchInput } from "../../../_uiComponents/Search/SkillSearchInput";
import "./CreateAssessmentKitTopic.scss";
import MainLayout from "../../Common/MainLayout";

export default (props) => {
  const {
    assessmentKit,
    loading,
    assessmentKitTopic,
    createQuestion,
    selectedQuestion,

    onBackClick,
    calculateAssessmentKitEstimatedTime,
    onDeleteTopicClick,
    onTopicTitleChange,
    onSelectedQustionChange,
    onSelectedQuestionSaveClick,
    onAddNewQuestionClick,
    onDeleteQuestionClick,
    onSaveNewTopicClick,
    searchSuggestedQuestionHandler,
    cancelUpdateEditTopic,
  } = useCreateAssessmentKitTopic(props);
  return (
    <MainLayout pageName={"Assessment kit Questions"}>
      <div className="create-assessmentkit-topic-wrapper">
        {assessmentKit?.id ? (
          <>
            <Container className="d-flex justify-content-between align-items-center">
              <h2 className="text-dark text-capitalize">
                {assessmentKit?.title}
              </h2>
              <span className="d-flex align-items-center ml-2">
                <button
                  className="btn border-0 bg-transparent text-dark"
                  onClick={onBackClick}
                >
                  Cancel & Return
                </button>
              </span>
            </Container>
            {loading ? (
              <div className="d-flex justify-content-center align-items-center w-100">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Container>
                <div className="my-3 row mx-0">
                  <div className="col-lg-9 bg-grey">
                    <div className="top bg-grey-2 py-3 px-4 mx-n3 d-flex justify-content-between align-items-center">
                      <h3 className="font-weight-medium pb-2 text-capitalize">
                        {assessmentKitTopic?.name || "Topic Name"}
                      </h3>
                      <span className="">
                        Estimated Time: {calculateAssessmentKitEstimatedTime()}{" "}
                        mins
                      </span>
                    </div>
                    <div className="bg-white border rounded-lg m-3">
                      <div className="top bg-grey-2 py-3 px-4 border d-flex justify-content-between align-items-center">
                        <div className="form-group mb-0 flex-grow-1 mr-3">
                          <input
                            className="form-control bg-white"
                            type="text"
                            placeholder="Enter topic name"
                            name="topic_name"
                            onBlur={(e) => {
                              onTopicTitleChange(e);
                            }}
                            defaultValue={assessmentKitTopic?.name}
                          />
                        </div>
                        {assessmentKitTopic?.name ? (
                          <>
                            <button
                              className="cursor-pointer border-0 bg-transparent font-weight-medium text-success"
                              onClick={onSaveNewTopicClick}
                            >
                              <FontAwesomeIcon
                                icon={faCheck}
                                className="mr-1"
                              />
                              Save
                            </button>
                            <button
                              className="cursor-pointer  border-0 bg-transparent font-weight-medium text-danger"
                              onClick={onDeleteTopicClick}
                            >
                              <FontAwesomeIcon
                                icon={faMinusCircle}
                                className="mr-1"
                              />
                              Delete
                            </button>
                          </>
                        ) : null}
                      </div>
                      <ol className="questions-wrapper mb-0 m-3">
                        {assessmentKitTopic?.questions &&
                          Array.isArray(assessmentKitTopic?.questions) &&
                          assessmentKitTopic.questions.map(
                            (question, index) => (
                              <>
                                {selectedQuestion &&
                                selectedQuestion?.id !== question?.id ? (
                                  <>
                                    <li className="list d-flex align-items-center mb-2">
                                      <span className="d-inline-block mr-2">
                                        <FontAwesomeIcon icon={faBars} />
                                      </span>
                                      <div className="inner-box d-flex flex-grow-1 mr-2 justify-content-between align-items-center  bg-grey border rounded-lg py-2 px-3">
                                        <p className="d-inline-block mb-0 mr-2 flex-grow-1">
                                          {question?.question}
                                        </p>
                                        <div className="d-flex flex-wrap justify-content-end">
                                          <p className="mb-0 d-inline-block text-primary fs-smallest ml-1 py-1 px-2 bg-light-blue rounded-sm mb-1">
                                            {question?.time_to_answer} mins to
                                            answer
                                          </p>
                                          <span className="mb-0 d-inline-block fs-smallest text-primary ml-1 py-1 px-2 bg-light-blue rounded-sm mb-1">
                                            {question?.skill_names &&
                                              question.skill_names[0]}
                                          </span>
                                          {/* <span className="mb-0 d-inline-block text-primary mr-2 py-1 px-2 bg-light-blue rounded-sm">
                                        {question?.is_public
                                          ? "Public"
                                          : "Private"}
                                      </span> */}
                                          <span className="mb-0 d-inline-block ml-1 fs-smallest text-primary py-1 px-2 bg-light-blue rounded-sm mb-1">
                                            {question?.difficulty_level}
                                          </span>
                                        </div>
                                      </div>
                                      <span
                                        className="cursor-pointer font-weight-medium"
                                        onClick={() =>
                                          onDeleteQuestionClick(question, index)
                                        }
                                      >
                                        <FontAwesomeIcon
                                          icon={faMinusCircle}
                                          className="ml-2 text-danger"
                                        />
                                      </span>
                                      <span
                                        className="cursor-pointer font-weight-medium text-success"
                                        onClick={() =>
                                          onAddNewQuestionClick(question)
                                        }
                                      >
                                        <FontAwesomeIcon
                                          icon={faPencil}
                                          className="ml-3"
                                        />
                                      </span>
                                    </li>
                                  </>
                                ) : null}

                                {selectedQuestion &&
                                selectedQuestion?.id === question?.id ? (
                                  <>
                                    <li>
                                      <Container>
                                        <Row className="mb-4 mt-3 ">
                                          <Col
                                            md={7}
                                            className="mb-4  mb-md-0 form-group"
                                          >
                                            <textarea
                                              rows="4"
                                              className="form-control h-100 bg-grey ques-input"
                                              name="question"
                                              onBlur={(e) => {
                                                onSelectedQustionChange(e);
                                              }}
                                              defaultValue={
                                                selectedQuestion?.question
                                              }
                                              placeholder="Enter your question here"
                                            ></textarea>
                                          </Col>

                                          <Col
                                            md={5}
                                            className="form-group mb-0"
                                          >
                                            <SkillSearchInput
                                              className="form-control w-100 mb-2"
                                              placeholder={"Skill Tag"}
                                              onSearchSelect={(item) =>
                                                onSelectedQustionChange({
                                                  target: {
                                                    value: item,
                                                    name: "skills",
                                                  },
                                                })
                                              }
                                              clearSearch={false}
                                              defaultSkillValue={
                                                selectedQuestion?.skill_names &&
                                                selectedQuestion?.skill_names[0]
                                              }
                                            />

                                            <div className="flex-grow-1 pt-2">
                                              <div className="form-group mb-0">
                                                <input
                                                  type="number"
                                                  className="form-control bg-grey mt-4"
                                                  placeholder="Enter time to answer"
                                                  name="time_to_answer"
                                                  onChange={(e) => {
                                                    onSelectedQustionChange(e);
                                                  }}
                                                  defaultValue={
                                                    selectedQuestion?.time_to_answer
                                                  }
                                                />
                                                mins
                                              </div>
                                            </div>
                                            <p className="fs-smallest font-weight-bold text-grey-4 mt-2">
                                              Select difficulty level
                                            </p>
                                            <div className="d-flex align-items-center justify-content-between flex-wrap">
                                              <div className="custom-control custom-radio mr-2">
                                                <input
                                                  type="radio"
                                                  className="custom-control-input"
                                                  id="editEasy"
                                                  value={"easy"}
                                                  defaultChecked={
                                                    selectedQuestion?.difficulty_level ===
                                                    "easy"
                                                  }
                                                  name="difficulty_level"
                                                  onChange={(e) => {
                                                    onSelectedQustionChange(e);
                                                  }}
                                                />
                                                <label
                                                  className="custom-control-label"
                                                  htmlFor={"editEasy"}
                                                  onChange={(e) => {
                                                    onSelectedQustionChange(e);
                                                  }}
                                                >
                                                  Easy
                                                </label>
                                              </div>
                                              <div className="custom-control custom-radio mr-2">
                                                <input
                                                  type="radio"
                                                  className="custom-control-input"
                                                  id="EditMedium"
                                                  value={"medium"}
                                                  name="difficulty_level"
                                                  defaultChecked={
                                                    selectedQuestion?.difficulty_level ===
                                                    "medium"
                                                  }
                                                  onChange={(e) => {
                                                    onSelectedQustionChange(e);
                                                  }}
                                                />
                                                <label
                                                  className="custom-control-label"
                                                  htmlFor={"EditMedium"}
                                                >
                                                  Medium
                                                </label>
                                              </div>
                                              <div className="custom-control custom-radio mr-2">
                                                <input
                                                  type="radio"
                                                  className="custom-control-input"
                                                  id="editHard"
                                                  value={"hard"}
                                                  name="difficulty_level"
                                                  defaultChecked={
                                                    selectedQuestion?.difficulty_level ===
                                                    "hard"
                                                  }
                                                  onChange={(e) => {
                                                    onSelectedQustionChange(e);
                                                  }}
                                                />
                                                <label
                                                  className="custom-control-label"
                                                  htmlFor={"editHard"}
                                                >
                                                  Hard
                                                </label>
                                              </div>
                                            </div>
                                          </Col>

                                          <Col
                                            md={12}
                                            className="d-flex align-items-center mt-4"
                                          >
                                            <div className="d-flex align-items-center">
                                              <button
                                                className="btn btn-primary mr-3 mb-1"
                                                onClick={() =>
                                                  onSelectedQuestionSaveClick()
                                                }
                                              >
                                                Update
                                              </button>
                                              <button
                                                className="btn btn-danger mr-3 mb-1"
                                                onClick={() =>
                                                  cancelUpdateEditTopic()
                                                }
                                              >
                                                Cancel
                                              </button>
                                            </div>
                                          </Col>
                                        </Row>
                                      </Container>
                                    </li>
                                  </>
                                ) : null}
                              </>
                            )
                          )}
                      </ol>

                      {/* create question  */}
                      {createQuestion ? (
                        <Container>
                          <Row className="mb-4 mt-3 ">
                            <Col md={7} className="mb-4  mb-md-0 form-group">
                              <textarea
                                rows="4"
                                className="form-control h-100 bg-grey ques-input"
                                name="question"
                                onBlur={(e) => {
                                  onSelectedQustionChange(e);
                                }}
                                onChange={(e) =>
                                  searchSuggestedQuestionHandler(e)
                                }
                                placeholder="Enter your question here"
                              ></textarea>
                            </Col>

                            <Col md={5} className="form-group mb-0">
                              <SkillSearchInput
                                className="form-control w-100"
                                placeholder={"Skill Tag"}
                                onSearchSelect={(item) =>
                                  onSelectedQustionChange({
                                    target: {
                                      value: item,
                                      name: "skills",
                                    },
                                  })
                                }
                                clearSearch={false}
                              />
                              <div className="form-group mb-0 d-flex align-items-end">
                                <input
                                  type="number"
                                  className="form-control bg-grey mt-2 w-50 mr-2"
                                  placeholder="Enter time to answer"
                                  name="time_to_answer"
                                  onChange={(e) => {
                                    onSelectedQustionChange(e);
                                  }}
                                />
                                mins
                              </div>
                              <p className="fs-smallest font-weight-bold text-grey-4 mt-2">
                                Select difficulty level
                              </p>
                              <div className="d-flex align-items-canter justify-content-between flex-wrap">
                                <div className="custom-control custom-radio mr-lg-4 mr-md-3 mr-xl-5">
                                  <input
                                    type="radio"
                                    className="custom-control-input"
                                    id="easy"
                                    value={"easy"}
                                    name="difficulty_level"
                                    onChange={(e) => {
                                      onSelectedQustionChange(e);
                                    }}
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor={"easy"}
                                    onChange={(e) => {
                                      onSelectedQustionChange(e);
                                    }}
                                  >
                                    Easy
                                  </label>
                                </div>
                                <div className="custom-control custom-radio  mr-lg-4 mr-md-3 mr-xl-5">
                                  <input
                                    type="radio"
                                    className="custom-control-input"
                                    id="medium"
                                    value={"medium"}
                                    name="difficulty_level"
                                    onChange={(e) => {
                                      onSelectedQustionChange(e);
                                    }}
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor={"medium"}
                                  >
                                    Medium
                                  </label>
                                </div>
                                <div className="custom-control custom-radio  mr-lg-4 mr-md-3 mr-xl-5">
                                  <input
                                    type="radio"
                                    className="custom-control-input"
                                    id="hard"
                                    value={"hard"}
                                    name="difficulty_level"
                                    onChange={(e) => {
                                      onSelectedQustionChange(e);
                                    }}
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor={"hard"}
                                  >
                                    Hard
                                  </label>
                                </div>
                              </div>
                            </Col>

                            <Col
                              md={12}
                              className="d-flex align-items-center mt-4"
                            >
                              <div className="left">
                                <button
                                  className="btn btn-primary mr-3"
                                  onClick={() => onSelectedQuestionSaveClick()}
                                >
                                  Save
                                </button>
                              </div>
                              <span
                                className="btn btn-danger"
                                onClick={() => cancelUpdateEditTopic()}
                              >
                                Cancel
                              </span>
                            </Col>
                          </Row>
                        </Container>
                      ) : (
                        <Col>
                          {selectedQuestion?.id ? null : (
                            <p
                              className="cursor-pointer text-primary font-weight-medium text-left"
                              onClick={() => onAddNewQuestionClick()}
                            >
                              + Add new question
                            </p>
                          )}
                        </Col>
                      )}
                    </div>
                  </div>
                </div>
              </Container>
            )}
          </>
        ) : (
          <p>Assessment Kit Not found.</p>
        )}
      </div>
    </MainLayout>
  );
};
